import React from "react";
import { Sun } from "lucide-react";
import SacredChatPage from "./SacredChatPage";
import { PLAYLISTS } from "@/lib/tracks";

const LESSON_TOPICS = {
  fr: [
    "Delphes et la Pythie",
    "Les 9 Muses",
    "Asclépios et la médecine",
    "La lyre à 7 cordes",
    "Gnōthi seauton (connais-toi)",
    "Hyperboréens (voyage du dieu)",
    "L'oracle vs la prophétie",
    "Daphné et le laurier",
    "Les Hymnes homériques",
    "Pindare et les Odes",
    "Apollon vs Dionysos",
    "La musique des sphères",
  ],
  en: [
    "Delphi and the Pythia",
    "The 9 Muses",
    "Asclepius and medicine",
    "The 7-string lyre",
    "Gnōthi seauton (know thyself)",
    "The Hyperboreans",
    "Oracle vs prophecy",
    "Daphne and the laurel",
    "The Homeric Hymns",
    "Pindar and the Odes",
    "Apollo vs Dionysus",
    "Music of the spheres",
  ],
};

export default function Apollon() {
  return (
    <SacredChatPage
      persona="apollon"
      personaLabel="Apollon"
      IconComponent={Sun}
      accent="#ff9a4a"
      theme={{
        bgRadial: "radial-gradient(ellipse at top, #2a1a08 0%, #1a0c04 55%, #080400 100%)",
        fg: "#ffe8d0",
        msgBg: "linear-gradient(180deg, rgba(32,18,8,0.92), rgba(10,5,2,0.95))",
        msgFg: "#f5c89a",
      }}
      title={{
        fr: <><span className="italic" style={{ color: "#ff9a4a" }}>Apollon</span>, l'ami lumineux.</>,
        en: <><span className="italic" style={{ color: "#ff9a4a" }}>Apollo</span>, the luminous friend.</>,
      }}
      subtitle={{
        fr: "☀️ Dieu de la lumière, de la musique, de la médecine et des Muses. Je suis l'ami doux et sage qui connaît tout — mais je ne décide jamais à ta place : je t'offre toujours plusieurs options et laisse ta liberté intacte.",
        en: "☀️ God of light, music, medicine and the Muses. I'm the gentle wise friend who knows all — but I never decide for you: I always offer several options and leave your freedom intact.",
      }}
      greeting={{
        fr: "« Approche, mon ami·e. Dis-moi — qu'est-ce qui t'inquiète ? Je vais t'offrir plusieurs lumières. »",
        en: "\"Come, my friend. Tell me — what weighs on you? I will offer you several lights.\"",
      }}
      suggestions={{
        fr: [
          "Je dois choisir entre deux carrières.",
          "Je ne sais pas quoi offrir à un ami cher.",
          "Mon enfant m'inquiète, quels chemins puis-je prendre ?",
          "Quelle discipline artistique devrais-je explorer ?",
        ],
        en: [
          "I must choose between two careers.",
          "I don't know what gift to give a dear friend.",
          "My child worries me, what paths can I take?",
          "Which art form should I explore?",
        ],
      }}
      playlist={PLAYLISTS.apollon}
      replySound={`${process.env.REACT_APP_BACKEND_URL}/api/static/audio/apollon_lyre.mp3`}
      sfxEmoji="🎵"
      sfxLabel={{ fr: "la lyre", en: "lyre" }}
      lessonMode={{
        endpoint: "/chat/apollon/lesson",
        title: {
          fr: "Choisis un sujet grec",
          en: "Pick a Greek topic",
        },
        topics: LESSON_TOPICS,
      }}
    />
  );
}
